<template>
<div class="chapter">
<div class="inner_page">
<div id="hryefm">
<p class="cImage"><img alt="History of the Rebel Yell display type.tif" src="Images/HistoryoftheRebel_fmt1.jpeg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title_half.vue?87277346